import { CURRENCY_LIST } from "../currencies";

export class CurrencySelector {
    id;
    defaultCurrency;
    selectCurrency;

    //callbacks
    onValueSelected;
    onChange;

  constructor(elMap = {selectCurrencyId: "Currency"}, defaultCurrency = "USD") {
    this.id = elMap.selectCurrencyId;
    this.selectCurrency = document.getElementById(elMap.selectCurrencyId);
    this.defaultCurrency = defaultCurrency;
    this.createCallbacks();
  }

  createCallbacks() {
    this.selectCurrency.innerHTML = null;

    CURRENCY_LIST.forEach((currency) => {
      const option = document.createElement('option');
      option.value = currency.value;
      option.innerHTML = currency.label;
      option.selected = currency.value === this.defaultCurrency;
      this.selectCurrency.add(option);
    });

    this.selectCurrency.addEventListener("change", ({ target: { options, selectedIndex } }) => this.onChange(selectedIndex, options[selectedIndex].value));
  
  }
}